import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

export default function SetupBanner() {
  const navigate = useNavigate();
  const { userConfig } = useUser();
  const setup = userConfig?.setup;

  if (!setup || (setup.has_api_key && setup.has_made_requests)) return null;

  return (
    <div className="mb-6 p-5 rounded-2xl border border-theme-secondary bg-gradient-to-r from-theme-primary/10 via-theme-primary/5 to-transparent">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <p className="text-theme-text font-medium">Get started with os-router</p>
          <p className="text-sm opacity-60 mt-1">
            Set up your project, create an API key, and send your first request in minutes.
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate('/setup/project/')}
          className="shrink-0 px-5 py-2.5 rounded-xl bg-theme-primary text-theme-button text-sm font-medium hover:opacity-90 transition-opacity"
        >
          Setup
        </button>
      </div>
    </div>
  );
}
